<template>
    <div :style="{'min-height':minHeight}" v-loading="loading" style="width:100%;background-color:rgba(0,0,0,0.05);display: flex;flex-direction: column;align-items: center;justify-content: flex-start;">
      <div style="width:1200px;background-color: #ffffff;margin:10px 0;font-size: 14px;display: flex;align-items:center;justify-content: center;padding:30px 0;">
          <table  border="0"  cellspacing="0" cellpadding="0"  style="border-style: none;border-color:#dddddd;text-align: center; width: 85%; border-collapse: collapse;">
            <tr>
                <td style="text-align: left;font-size: 20px;font-weight: bold;height: 50px;">
                  用户注册
                </td>
            </tr>
            <tr>
                <td style="color:#ff0000;font-weight: bold;">
                  <div style="text-align: left;">
                    1. 请使用二代身份证进行注册，同一身份证只能注册一次。
                  </div>
                  <div style="text-align: left;">
                    2. 注册时请正确填写邮箱地址，之后将作为登录账号以及接收邮件使用。
                  </div>
                  <div style="text-align: left;">
                    3. 在本网站标题栏点击【注册】按钮进行注册（根据提示填写真实用户信息,以备后续使用）。
                  </div>
                </td>
            </tr>
            <tr>
              <td style="text-align: left;font-size: 20px;font-weight: bold;height: 50px;">
                简历填写
              </td>
            </tr>
            <tr>
              <td style="text-align: left;color:#888888;">
                通过帐号密码登录招聘系统后请填写真实的个人基本信息、教育经历、工作履历、家庭成员等信息。
              </td>
            </tr>
            <tr>
              <td style="text-align: left;font-size: 20px;font-weight: bold;height: 50px;">
                应聘者报名时需上传材料
              </td>
            </tr>
            <tr>
              <td>
                <table  border="1"  cellspacing="0" cellpadding="0"  style="border-style: none;border-color:#dddddd;text-align: center; width: 85%; border-collapse: collapse;">
                  <tr style="height:40px;">
                    <td style="width:20%;font-weight: bold;">
                      应聘岗位
                    </td>
                    <td style="width:80%;font-weight: bold;">
                      上传资料
                    </td>
                  </tr>
                  <tr v-if="applyKnowList.length>0" v-for="item in applyKnowList">
                    <td>
                      {{item.jobTitle}}
                    </td>
                    <td style="text-align: left;">
                      <div v-html="item.content" style="width:100%;box-sizing: border-box;padding: 6px;"></div>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr style="display:none;">
              <td style="text-align: left;color:#ff0000;font-weight: bold;">
                注意：简历信息填写好后，应聘者需将报名表打印出来（打印位置：个人中心—我的简历—预览—下载），找相关单位签字盖章，然后将签字盖章后的报名表作为附件上传至个人简历。
              </td>
            </tr>
            <tr>
              <td style="text-align: left;font-size: 20px;font-weight: bold;height: 50px;">
                应聘岗位
              </td>
            </tr>
            <tr>
              <td style="text-align: left;color:#888888;">
                应聘岗位之前请仔细核对好简历信息和需要应聘的岗位信息。除教学科研岗，其他岗位每一批招聘每人只可应聘1个岗位。
              </td>
            </tr>

            <tr>
              <td style="text-align: left;font-size: 20px;font-weight: bold;height: 50px;">
                ★无法填写/保存的问题★
              </td>
            </tr>
            <tr>
              <td style="text-align: left;color:#888888;">
              1.推荐使用谷歌浏览器（或者带有chrome内核的浏览器）。
            </td>
            </tr>
            <tr>
              <td style="text-align: left;font-size: 20px;font-weight: bold;height: 50px;">
                ★上传非法附件的问题★
              </td>
            </tr>
            <tr>
              <td style="text-align: left;color:#888888;">
                1.附件的路径中不允许含有(空格、百分号、引号、)等特殊符号，建议将上传路径设为桌面。
              </td>
            </tr>

          </table>
      </div>
  </div>
</template>
<script>
    export default {
        props: ['pJobId'],
        name: 'ApplyKnow',
        data () {
            return {
              loading:false,
              minHeight:'100%',
              applyKnowList:[],
            }
        },
        methods:{
            getDataList:function(){
                var that = this;
                that.loading=true;
                this.$axios.get(this.Global.globalUrl+'/interface/getApplyKnow.ashx'
                        ,{params:{
                        jobId:this.pJobId,
                    }}
                    ).then((res) => {
                    that.applyKnowList=res.data.applyKnowList;
                    })
                    .catch(() => {
                    })
                    .finally(()=>{
                      setTimeout(() => {
                    that.loading=false;
                }, 1000);                

                    })

            },

        },
        mounted(){
            this.$nextTick(function () {
                this.minHeight = (document.documentElement.clientHeight -200)+'px';
                this.getDataList();
            })
        }

    }
</script>

<style scoped>
</style>